<template>
  <Teleport to="body">
    <div :id="overlayId" :class="['modal-overlay', overlayClass]">
      <div :class="[modalContentDefaultClass, modalContentClass]">
        <div
          v-if="closeButtonVisible"
          id="closeModalBtn"
          class="close-btn"
        >
          <BaseImage src="/static/images/x.svg" alt="close" />
        </div>

        <div class="modal-card">
          <slot name="default"></slot>
        </div>
      </div>

      <slot name="bottom"></slot>
    </div>
  </Teleport>
</template>

<script setup>
import { onUnmounted } from 'vue';
import BaseImage from '@/components/image/BaseImage.vue';

defineProps({
  closeButtonVisible: {
    type: Boolean,
    default: true,
  },
  overlayId: {
    type: String,
    default: 'modalOverlay',
  },
  overlayClass: {
    type: [String, Array, Object],
    default: '',
  },
  modalContentDefaultClass: {
    type: String,
    default: 'modal-content',
  },
  modalContentClass: {
    type: [String, Array, Object],
    default: '',
  },
});

onUnmounted(() => {
  const bodyEl = document.querySelector('body');

  if (bodyEl && bodyEl.classList.contains('no-scroll')) {
    bodyEl.classList.remove('no-scroll');
  }
});
</script>
